// extracted by mini-css-extract-plugin
export default {"container":"DialogCard_container__wY5sS","main":"DialogCard_main__ALIDw","header":"DialogCard_header__QZio6","content":"DialogCard_content__PxVP+"};